import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	noResults: {
		id: 'app.searchBar.noResults',
		defaultMessage: 'There are no {formattedFilters} results for <b>"{query}"</b>.',
		description: 'Message when no results are found',
	},
	searchSuggestion: {
		id: 'app.searchBar.searchSuggestion',
		defaultMessage: "Try searching for a topic like 'Gratitude'.",
		description: 'Suggestion of what to search for when no results are found',
	},
	fallBackResults: {
		id: 'app.searchBar.noResultsfallBackResults',
		defaultMessage:
			"There are no {formattedFilters} results for <b>{query}</b>, but these may be what you're looking for.",
		description:
			'Message when no results are found based on the filters that were selected but there are results based on the query',
	},
	searchSubmit: {
		id: 'app.searchBar.searchSubmit',
		defaultMessage: 'Search',
		description: 'Search submit button text',
	},
	searchCategory: {
		id: 'app.searchBar.searchCategory',
		defaultMessage: 'Category',
		description: 'Search category placeholder text',
	},
	searchTime: {
		id: 'app.searchBar.searchTime',
		defaultMessage: 'Time',
		description: 'Search time placeholder text',
	},
	searchClear: {
		id: 'app.searchBar.searchClear',
		defaultMessage: 'Clear All',
		description: 'Search clear all button text',
	},
});
